module.exports = __webpack_public_path__ + "img/18.45cf9a48.jpeg";